/* eslint-disable max-len */
import 'react';

const EnterSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" />
            <path
                d="M14.921 3.981a.75.75 0 01.744.649l.006.101v4.242a2.75 2.75 0 01-2.582 2.745l-.168.005H5.253a.75.75 0 01-.101-1.493l.101-.007h7.668a1.25 1.25 0 001.244-1.122l.006-.128V4.731a.75.75 0 01.75-.75z"
                fill="currentColor"
                fillRule="nonzero"
            />
            <path
                d="M8.006 7.16a.75.75 0 011.134.976l-.073.084-2.754 2.753 2.754 2.753a.75.75 0 01.073.977l-.073.084a.75.75 0 01-.976.073l-.085-.073-3.283-3.283a.75.75 0 01-.073-.977l.073-.084L8.006 7.16z"
                fill="currentColor"
                fillRule="nonzero"
            />
        </g>
    </svg>
);

export default EnterSvg;
